import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { IconButton } from '@mui/material';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { IUserProfile } from '../../../../store/user/user.interface';
import AddButton from '../../../../ui/checkout/AddButton/AddButton';
import CheckoutField from '../../../../ui/form-elements/CheckoutField/CheckoutField';

import styles from './ContactInformation.module.sass';

interface IAddRegistration {
  isUserOrg: boolean;
  user: IUserProfile | null;
  onClearValue: () => void;
  setHandleModal: (show: boolean) => void;
}
const AddRegistration: FC<IAddRegistration> = ({
  isUserOrg,
  user,
  onClearValue,
  setHandleModal,
}) => {
  const { control, getValues } = useFormContext();
  
  return (
    <>
      {isUserOrg ? (
        <div className={styles.orgField}>
          <Controller
            name="orgName"
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <CheckoutField
                  className={styles.org}
                  label="Организация"
                  defaultValue={getValues('orgName')}
                  required
                  onChange={onChange}
                  value={value}
                  // @ts-ignore
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <IconButton
                        className={styles.close}
                        onClick={onClearValue}
                        edge="end"
                      >
                        <CloseRoundedIcon />
                      </IconButton>
                    ),
                  }}
                />
              );
            }}
          />
        </div>
      ) : (
        <AddButton onClick={() => setHandleModal(true)} />
      )}
    </>
  );
};

export default AddRegistration;
